'use strict';

const createOneClickCheckoutFactory = require('./main_creator');

module.exports = createOneClickCheckoutFactory({
    viewClass: require('./view.desktop'),
    isEnabled() {
        return Odigeo.AB.isOneClickCheckout || Odigeo.AB.isOneClickCheckoutCheckinMicrofunnel;
    },
});
